// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"122":"2fc1174e","453":"68307aa4"}[chunkId] + ".chunk.js";
};